import { CELL_STYLES, type AvailabilityGridCell } from './roster-shared';

/** One heatmap cell. `shift` = assigned that day; the four slot values are
 *  what the teacher declared (BON-241); `null` = they haven't set anything.
 *  Undeclared is deliberately distinct from "off" — before BON-241 every
 *  cell defaulted to available, asserting something nobody had declared. */
export default function AvailabilityCell({ value }: { value: AvailabilityGridCell }) {
  // Undeclared (null) renders as a bare dot — see the "N of M set" hint.
  const style = value === null ? undefined : CELL_STYLES[value];
  if (!style) return <span style={{ color: 'var(--nb-faint)' }}>·</span>;
  return (
    <span
      style={{
        display: 'inline-block',
        width: 14,
        height: 14,
        borderRadius: 3,
        ...style.swatch,
      }}
      title={style.label}
    />
  );
}
